import type { PropsWithChildren } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { MARKETING_ROUTES } from "../constants/marketing-routes";
import { SiteFooter } from "./site-footer";
import { SiteHeader } from "./site-header";

export function SiteShell({ children }: PropsWithChildren) {
	const location = useLocation();

	useEffect(() => {
		if (location.pathname !== MARKETING_ROUTES.HOME || location.hash.length < 2) {
			return;
		}
		const id = location.hash.slice(1);
		let attempts = 0;
		const tryScroll = () => {
			const el = document.getElementById(id);
			if (el) {
				el.scrollIntoView({ behavior: "smooth", block: "start" });
				return;
			}
			if (attempts < 24) {
				attempts += 1;
				requestAnimationFrame(tryScroll);
			}
		};
		tryScroll();
	}, [location.pathname, location.hash]);

	return (
		<div className="min-h-screen bg-[radial-gradient(circle_at_top_left,rgba(255,90,95,0.18),transparent_28%),radial-gradient(circle_at_top_right,rgba(78,141,255,0.16),transparent_26%),linear-gradient(180deg,#05070c_0%,#080b12_42%,#0f1420_100%)] text-white">
			<div className="mx-auto max-w-7xl px-6 pb-16 pt-6 sm:px-8 lg:px-12">
				<SiteHeader />
			</div>
			{children}
			<div className="mx-auto max-w-7xl px-6 pb-12 sm:px-8 lg:px-12">
				<SiteFooter />
			</div>
		</div>
	);
}
